import { HttpErrorResponse } from '@angular/common/http'
import { Action, createAction, props } from '@ngrx/store'
import { AmountBreakdownDialogTypeEnum } from '../../../../feature/src/lib/gb-amount-breakdown-dialog/gb-amount-breakdown-dialog.component'
import { AddPaymentPayload, DashboardPaymentEntity, RefundReasonsEnum } from './payments.models'

export const loadPayments = createAction(
  '[Payments Page] Load Payments',
  props<{
    searchTerm: string
    profile_uuid?: string
    ordering?: string
    shouldReset?: boolean
  }>(),
)

export const loadPaymentsSuccess = createAction(
  '[Payments/API] Load Payments Success',
  props<{ payments: DashboardPaymentEntity[]; count: number }>(),
)
export const setPayments = createAction(
  '[Payments/API] Set Payments',
  props<{ payments: DashboardPaymentEntity[]; count: number }>(),
)

export const loadPaymentsFailure = createAction(
  '[Payments/API] Load Payments Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const openAddPaymentDialog = createAction(
  '[Payments/API] Open Add Payment Dialog',
  props<{ clearSelectedInvoice: boolean; disableAmount?: boolean; onSuccess?: () => void }>(),
)

export const addPayment = createAction(
  '[Payments Page] Add Payment',
  props<{ payload: AddPaymentPayload; onSuccess?: () => Action }>(),
)

export const addPaymentSuccess = createAction(
  '[Payments/API] Add Payment Success',
  props<{ payment: DashboardPaymentEntity; onSuccess?: () => Action }>(),
)

export const addPaymentFailure = createAction(
  '[Payments/API] Add Payment Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const showPaymentDialogSuccess = createAction('[Payments Page] show Payment Dialog Success')

export const checkout = createAction(
  '[Payments Page] checkout Payment',
  props<{ payload: AddPaymentPayload; onSuccess?: () => void }>(),
)

export const checkoutSuccess = createAction(
  '[Payments/API] checkout Success',
  props<{ payment: DashboardPaymentEntity; onSuccess?: () => void }>(),
)

export const checkoutFailure = createAction('[Payments/API] checkout Failure', props<{ error: HttpErrorResponse }>())

export const selectPayment = createAction('[Payments Page] Select Payment', props<{ payment_uuid: string }>())

export const openRefundPaymentDialog = createAction(
  '[Payments Page] Open Refund Payment Dialog',
  props<{ payment: DashboardPaymentEntity }>(),
)

export const refundPayment = createAction(
  '[Payments/API] Refund Payment',
  props<{ payment: DashboardPaymentEntity; refund_amount: number; refund_reason: RefundReasonsEnum }>(),
)

export const refundPaymentSuccess = createAction(
  '[Payments/API] Refund Payment Success',
  props<{ payment: DashboardPaymentEntity }>(),
)

export const refundPaymentFailure = createAction(
  '[Payments/API] Refund Payment Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const openAmountBreakdownDialog = createAction(
  '[Payments Page] Open Amount Breakdown Dialog',
  props<{
    payment_uuid: string
    breakdown_type: AmountBreakdownDialogTypeEnum
  }>(),
)

export const displayGrid = createAction('[Payments/Page] Display Grid View')

export const displayTable = createAction('[Payments/Page] Display Table View')

export const refundPaymentDonation = createAction(
  '[Payments/API] Refund Payment Donation',
  props<{ payment: DashboardPaymentEntity }>(),
)

export const refundTip = createAction('[Payments/API] Refund Tip', props<{ payment: DashboardPaymentEntity }>())

export const refundTipSuccess = createAction(
  '[Payments/API] Refund Tip Success',
  props<{ payment: DashboardPaymentEntity }>(),
)

export const refundTipFailure = createAction('[Payments/API] Refund Tip Failure', props<{ error: HttpErrorResponse }>())
